import React from 'react';

/**
 * AppButton — botón reutilizable con la jerarquía de variantes de color acordada:
 *
 *   Variante      | Texto     | Fondo     | Borde
 *   --------------|-----------|-----------|----------
 *   principal     | #FFFFFF   | #07354F   | #07354F
 *   secundario1   | #07354F   | #FFFFFF   | #07354F
 *   secundario2   | #FFFFFF   | #B4B4B4   | #B4B4B4
 *   secundario3   | #B4B4B4   | #FFFFFF   | #B4B4B4
 *   negativo      | #C4122F   | #FFFFFF   | #C4122F
 *
 * Uso:
 *   <AppButton variant="principal" onClick={handleGuardar}>Guardar</AppButton>
 *   <AppButton variant="negativo" onClick={handleCancelar}>Cancelar</AppButton>
 *
 * El color se aplica siempre vía `style` inline (no depende de clases de color ya
 * existentes en el proyecto, como btn-color-rojo-borde/btn-color-verdefull, para no
 * chocar con esos otros usos ni depender del CSS compilado del bundle). Las clases
 * `btn btn-default` se mantienen para conservar el resto del look (padding, radio,
 * tipografía) ya estandarizado por Bootstrap en el CMS.
 */
const VARIANT_STYLES = {
    principal:   { color: '#FFFFFF', backgroundColor: '#07354F', borderColor: '#07354F' },
    secundario1: { color: '#07354F', backgroundColor: '#FFFFFF', borderColor: '#07354F' },
    secundario2: { color: '#FFFFFF', backgroundColor: '#B4B4B4', borderColor: '#B4B4B4' },
    secundario3: { color: '#B4B4B4', backgroundColor: '#FFFFFF', borderColor: '#B4B4B4' },
    negativo:    { color: '#C4122F', backgroundColor: '#FFFFFF', borderColor: '#C4122F' },
};

const AppButton = ({
    variant = 'principal',
    type = 'button',
    className = '',
    style,
    disabled,
    children,
    ...rest
}) => {
    const variantStyle = VARIANT_STYLES[variant] || VARIANT_STYLES.principal;

    return (
        <button
            type={type}
            className={`btn btn-default ${className}`.trim()}
            style={{
                ...variantStyle,
                border: '1px solid',
                fontWeight: 'normal',
                opacity: disabled ? 0.65 : 1,
                ...style,
            }}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
};

export default AppButton;
